import { useParams } from "react-router-dom";

export function useRequiredParams<K extends string>(): Record<K, string> {
  const params = useParams<Record<K, string>>();

  const entries = Object.entries(params) as [K, string | undefined][];
  for (const [key, value] of entries) {
    if (value === undefined) {
      throw new Error(`Missing required route parameter: ${key}`);
    }
  }

  return params as Record<K, string>;
}
